import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/**
 * Shared query client (docs/spec.md §2).
 *
 * Clinic screens are read often and edited rarely, so data is cached briefly
 * and refetched when a window regains focus — a receptionist coming back to the
 * diary should see what the doctor just changed.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // Retrying an auth or permission failure just delays the redirect;
        // the answer will not change.
        if (error instanceof ApiError) {
          if (
            error.code === 'UNAUTHENTICATED' ||
            error.code === 'FORBIDDEN' ||
            error.code === 'NOT_FOUND' ||
            error.code === 'VALIDATION_FAILED'
          ) {
            return false;
          }
        }
        return failureCount < 2;
      },
    },
    mutations: {
      // A failed save must surface, not silently repeat — a retried invoice or
      // stock movement could double-apply.
      retry: false,
    },
  },
});
